import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { SavingsInformFields } from "../partials/FormFields";

const SavingsForm = ({ AFdata }) => {
	const [formData, setFormData] = useState(AFdata);

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<div className='RightSection w-full'>
					<FormAccordion title='Savings Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							<SavingsInformFields
								formData={formData}
								// isEditable={isEditable}
								handleInputChange={handleInputChange}
							/>
						</div>
					</FormAccordion>
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
SavingsForm.propTypes = {
	AFdata: PropTypes.object,
	setAFdata: PropTypes.func,
	updateCurrentObject: PropTypes.func,
};

export default SavingsForm;
